"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariablePreserveTransformer = void 0;
const inversify_1 = require("inversify");
const NodeTransformer_1 = require("../../enums/node-transformers/NodeTransformer");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const NodeTransformationStage_1 = require("../../enums/node-transformers/NodeTransformationStage");
const AbstractNodeTransformer_1 = require("../AbstractNodeTransformer");
const NodeGuards_1 = require("../../node/NodeGuards");
let VariablePreserveTransformer = class VariablePreserveTransformer extends AbstractNodeTransformer_1.AbstractNodeTransformer {
    constructor(identifierReplacer, randomGenerator, options, scopeIdentifiersTraverser) {
        super(randomGenerator, options);
        this.runAfter = [NodeTransformer_1.NodeTransformer.ParentificationTransformer];
        this.runOnProgramNodeOnly = true;
        this.identifierReplacer = identifierReplacer;
        this.scopeIdentifiersTraverser = scopeIdentifiersTraverser;
        this.preserveScopeVariableIdentifiers = this.preserveScopeVariableIdentifiers.bind(this);
    }
    getVisitor(nodeTransformationStage) {
        const visitor = {
            enter: (node, parentNode) => {
                if (parentNode && NodeGuards_1.NodeGuards.isProgramNode(node)) {
                    return this.transformNode(node);
                }
            }
        };
        switch (nodeTransformationStage) {
            case NodeTransformationStage_1.NodeTransformationStage.Preparing:
            case NodeTransformationStage_1.NodeTransformationStage.RenameIdentifiers:
                return visitor;
            case NodeTransformationStage_1.NodeTransformationStage.Converting:
                return this.shouldPreserveConvertingStageIdentifiers() ? visitor : null;
            default:
                return null;
        }
    }
    transformNode(programNode) {
        this.scopeIdentifiersTraverser.traverseScopeIdentifiers(programNode, this.preserveScopeVariableIdentifiers);
        return programNode;
    }
    preserveScopeVariableIdentifiers(data) {
        const { isGlobalDeclaration, isBubblingDeclaration, variable, variableScope } = data;
        for (const identifier of variable.identifiers) {
            if (isGlobalDeclaration || isBubblingDeclaration) {
                this.preserveIdentifierNameForRootLexicalScope(identifier);
            }
            else {
                this.preserveIdentifierNameForLexicalScope(identifier, variableScope);
            }
        }
    }
    preserveIdentifierNameForRootLexicalScope(identifierNode) {
        this.identifierReplacer.preserveName(identifierNode);
    }
    preserveIdentifierNameForLexicalScope(identifierNode, variableScope) {
        const lexicalScopeNode = NodeGuards_1.NodeGuards.isNodeWithLexicalScope(variableScope.block)
            ? variableScope.block
            : null;
        if (!lexicalScopeNode) {
            return;
        }
        this.identifierReplacer.preserveNameForLexicalScope(identifierNode, lexicalScopeNode);
    }
    shouldPreserveConvertingStageIdentifiers() {
        return (this.options.controlFlowFlattening ||
            this.options.deadCodeInjection ||
            this.options.stringArray ||
            this.options.transformObjectKeys);
    }
};
exports.VariablePreserveTransformer = VariablePreserveTransformer;
exports.VariablePreserveTransformer = VariablePreserveTransformer = __decorate([
    (0, inversify_1.injectFromBase)(),
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IIdentifierReplacer)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IScopeIdentifiersTraverser)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], VariablePreserveTransformer);
